import styled from "styled-components";
const Text = styled.div`
    font-size: 12px;
    a {
        color: #fff;
    }
`;
export default Text;
